<template>
  <div class="flex pt-11 lg:pt-26px space-x-28">
    <router-link class="link" :to="{name:'home'}">{{ $t('main') }}</router-link>
    <router-link class="link" :to="{name:'transactions'}">{{ $t('transactions') }}</router-link>
    <router-link class="link" :to="{name:'reports'}">{{ $t('reports') }}</router-link>
    <router-link class="link" :to="{name:'budget'}">{{ $t('budget') }}</router-link>
    <router-link class="link" :to="{name:'calendar'}">{{ $t('calendar') }}</router-link>
    <router-link class="link" :to="{name:'goals'}">{{ $t('goals') }}</router-link>
  </div>
</template>

<script>
export default {
  name: "MoneyNavigation",
  i18n: {
    messages: {
      en: {
        main: 'Main',
        transactions: 'Transactions',
        reports: 'Reports',
        budget: 'Budget',
        calendar: 'Calendar',
        goals: 'Goals',
      },
      ru: {
        main: 'Главная',
        transactions: 'Операции',
        reports: 'Отчеты',
        budget: 'Бюджет',
        goals: 'Цели',
        calendar: 'Календарь',
      }
    }
  }
}
</script>
